const colorToHsla = (color) => {
  return color.replace(/\%/g,'').slice(5, color.indexOf(')') - 2).split(',');
}

export default colorToHsla;
